import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import Pagination from '../Pagination'
import RowsPerPage from '../RowsPerPage'

import Cards from '../Cards'
import TopControls from '../TopControls'

import Loading from '../Loading'

const TableCards = ({
  topControls,
  tablePayload,
  className,
  filterGroups,
  getFilterGroups,
  saveFilterGroup,
  deleteFilterGroup,
  renderHeader,
  renderCustom,
  renderPinned,
  modalTitle,
  renderModalFooter,
  loading = false,
  cardWidth = 500,
  cardGap = 1,
  cardCountGap = [6, 12, 24, 48],
  showModal = true,
  displayBottomControls = true
}) => {
  const tableElement = useRef(null)

  const activeColumns = tablePayload.schema
    .filter((d) => d.isColumn !== false && d.isColumnVisible !== false && d.name !== tablePayload.stickyColumn?.name)

  return (
    <div className={`table-wrapper ${className}`}>

      {loading && (
        <div
          className='w-100 h-100 position-absolute d-flex justify-content-center align-items-center'
          style={{
            zIndex: '1000'
            // backgroundColor: 'rgba(130, 130, 130, 0.10)'
          }}
        >
          <Loading />
        </div>
      )}

      {/* TABLE TOP CONTROLS */}
      {<TopControls
        topControls={topControls}
        tablePayload={tablePayload}
        filterGroups={filterGroups}
        getFilterGroups={getFilterGroups}
        saveFilterGroup={saveFilterGroup}
        deleteFilterGroup={deleteFilterGroup}
        cards={true}
        disabled={loading}
      />}

      {/* TABLE CONTENT */}
      <div
        className='table border-0 px-1'
        ref={tableElement}
        style={renderCustom ? {} : {
          gridTemplateColumns: `repeat(auto-fit, minmax(${cardWidth}px, 1fr))`,
          gap: `${cardGap}rem`
        }}
      >
        <Cards
          tablePayload={tablePayload}
          activeColumns={activeColumns}
          renderHeader={renderHeader}
          renderPinned={renderPinned}
          renderCustom={renderCustom}
          loading={loading}
          modalTitle={modalTitle}
          renderModalFooter={renderModalFooter}
          showModal={showModal}
        />
      </div>

      {/* TABLE BOTTOM CONTROLS */}
      {displayBottomControls
        ? (<div className='d-flex flex-column flex-md-row justify-content-between align-items-center mt-4'>
          <div className='fw-semibold text-muted text-nowrap'>
            {`${tablePayload.assembledDataLength} item${tablePayload.assembledDataLength === 1 ? '' : 's'}`}
          </div>
          {tablePayload.totalPages > 1 && (
            <Pagination
              totalPages={tablePayload.totalPages}
              prevDisabled={tablePayload.prevDisabled || loading}
              nextDisabled={tablePayload.nextDisabled || loading}
              setPageNumber={tablePayload.setCurrentPage}
              pageNumber={tablePayload.currentPage}
            />
          )}
          <RowsPerPage
            rowsPerPage={tablePayload.rowsPerPage}
            setRowsPerPage={tablePayload.setRowsPerPage}
            gap={cardCountGap}
            disabled={loading}
            cards={true}
          />
        </div>)
        : (
          <div className='fw-semibold text-muted text-nowrap mt-4'>
            {`${tablePayload.assembledDataLength} item${tablePayload.assembledDataLength === 1 ? '' : 's'}`}
          </div>
        )
      }

    </div>
  )
}

TableCards.propTypes = {
  topControls: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.element
  ]),
  tablePayload: PropTypes.object,
  className: PropTypes.string,
  filterGroups: PropTypes.array,
  getFilterGroups: PropTypes.func,
  saveFilterGroup: PropTypes.func,
  deleteFilterGroup: PropTypes.func,
  renderHeader: PropTypes.func,
  cardWidth: PropTypes.number,
  cardGap: PropTypes.number,
  renderPinned: PropTypes.func,
  renderCustom: PropTypes.func,
  modalTitle: PropTypes.func,
  renderModalFooter: PropTypes.func,
  cardCountGap: PropTypes.array,
  loading: PropTypes.bool,
  showModal: PropTypes.bool,
  displayBottomControls: PropTypes.bool
}

export default TableCards
